<template>
    <Screen>
        <AppBar
            title="Manage blissdom categories"
            :description="`Add or update BIBO app blissdom categories`"
            :showBackButton="false"
        >
            <inertia-link
                :href="$route('admin.blissdom.categories.create')"
                class="btn btn-sm btn-primary"
            >
                <i class="fa fa-plus"></i>
                <span class="d-none d-app-inline">Add new</span>
            </inertia-link>
        </AppBar>
        <Breadcrumbs title="Blissdom Categories" />
        <div class="card">
            <div class="card-body">
                <SearchBar
                    @onSubmit="searchSubmit"
                    @onClear="searchCleared"
                    v-model="searchInput"
                />
                <div class="table-responsive" v-if="data.data.length > 0">
                    <table class="table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>#</th>
                                <th>Icon</th>
                                <th>Name</th>
                                <th>Sort order</th>
                                <th>Sections</th>
                                <th>Status</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in data.data" :key="item.id">
                                <td>
                                    {{
                                        i +
                                        1 +
                                        (data.meta.current_page - 1) *
                                            data.meta.per_page
                                    }}
                                </td>
                                <td>
                                    <img
                                        v-lazy="item.icon"
                                        :alt="item.name"
                                        class="preview-img-sm"
                                        width="80"
                                        height="80"
                                        style="background-color: #f1f1f1"
                                    />
                                </td>
                                <th style="max-width: 220px">
                                    <div>{{ item.name }}</div>
                                </th>
                                <td>{{ item.sort_order }}</td>
                                <th>
                                    <span class="mr-2">{{
                                        item.sections_count || 0
                                    }}</span>
                                    <inertia-link
                                        :href="
                                            $route(
                                                'admin.blissdom.sections.index',
                                                {
                                                    category: item.id,
                                                }
                                            )
                                        "
                                        class="btn btn-light btn-rounded-sm"
                                        v-tooltip="'View activities'"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </inertia-link>
                                    <inertia-link
                                        :href="
                                            $route(
                                                'admin.blissdom.sections.create',
                                                {
                                                    category: item.id,
                                                }
                                            )
                                        "
                                        class="btn btn-light btn-rounded-sm"
                                        v-tooltip="'Add new activity'"
                                    >
                                        <i class="fa fa-plus"></i>
                                    </inertia-link>
                                </th>
                                <th>
                                    <StatusSwitch
                                        :dataid="item.id"
                                        :status="item.isactive"
                                        action="blissdomCategoryStatus"
                                    />
                                </th>
                                <td>{{ item.created_at_human || "-" }}</td>
                                <td>{{ item.updated_at_human || "-" }}</td>
                                <td>
                                    <inertia-link
                                        class="btn btn-sm btn-light"
                                        :href="
                                            $route(
                                                'admin.blissdom.categories.edit',
                                                {
                                                    id: item.id,
                                                }
                                            )
                                        "
                                    >
                                        Update
                                    </inertia-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <NoData title="No blissdom categories added yet" v-else>
                    <inertia-link
                        :href="$route('admin.blissdom.categories.create')"
                        class="btn btn-primary"
                    >
                        <i class="fa fa-plus"></i> Add new
                    </inertia-link>
                </NoData>
                <Pagination :rawData="data.meta" :onClick="pageChange" />
            </div>
        </div>
    </Screen>
</template>
<script>
export default {
    components: {},
    props: {
        data: {
            type: [Array, Object],
            default: () => [],
        },
        search: {
            type: String,
            default: "",
        },
    },
    watch: {
        search: {
            immediate: true,
            handler(value) {
                this.searchInput = value;
            },
        },
    },
    data() {
        return {
            searchInput: "",
        };
    },
    mounted() {},
    methods: {
        searchSubmit(search) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: search,
                    page: 1,
                })
            );
        },
        searchCleared() {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: "",
                    page: 1,
                })
            );
        },
        pageChange(page) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    page: page,
                    search: this.searchInput,
                })
            );
        },
    },
    computed: {},
};
</script>
